import { render, staticRenderFns } from "./single_list_v2.vue?vue&type=template&id=5aea9ec8&scoped=true&"
import script from "./single_list_v2.vue?vue&type=script&lang=js&"
export * from "./single_list_v2.vue?vue&type=script&lang=js&"
import style0 from "./single_list_v2.vue?vue&type=style&index=0&id=5aea9ec8&prod&lang=scss&"
import style1 from "./single_list_v2.vue?vue&type=style&index=1&id=5aea9ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea9ec8",
  null
  
)

export default component.exports